// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607090506/js/" + chunkId + "." + {"44":"9eceb9ca","225":"b0705ce1","481":"3a30e7ef","486":"6b84bfd3","770":"e115d8bb"}[chunkId] + ".0.7088065968702623.chunk.js";
};